import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { changeCategories, changeContext, changeFolder } from '../../actions/publish';
import { Button, InputLabel, MultiSelect, Select } from '../../styled-components';
import localize from '../../util/localizeUtils';
import { ButtonContainer, TabContentContainer } from './styled-components';

const Field = styled.div`
  margin-bottom: 0.5rem;
`;

class LuciTabContent extends React.PureComponent {
  onChangeCategories = selectedCategories => {
    const selectedIds = selectedCategories.map(c => c.id);
    this.props.onChangeCategories(selectedIds);
  };

  onChangeContext = event => {
    this.props.onChangeContext(parseInt(event.target.value, 10));
  };

  onChangeFolder = event => {
    this.props.onChangeFolder(parseInt(event.target.value, 10));
  };

  render() {
    const contextList = this.props.contextList.map(x => x);
    if (!contextList.some(c => c.id === -1)) {
      contextList.unshift({ id: -1, name: localize('selectContextOption') });
    }

    const categoryOptions = this.props.categoryList.map(category => ({
      ...category,
      selected: this.props.selectedCategoryIds
        ? this.props.selectedCategoryIds.some(i => i === category.id)
        : false
    }));
    return (
      <TabContentContainer>
        <Field>
          <InputLabel>{localize('luciContextLabel')}</InputLabel>
          <Select width="100%" onChange={this.onChangeContext}>
            {contextList.map(context => (
              <option
                disabled={context.id === -1 && this.props.selectedContextId !== -1}
                key={context.id}
                value={context.id}
              >
                {context.name}
              </option>
            ))}
          </Select>
        </Field>
        <Field>
          <InputLabel>{localize('luciFolderLabel')}</InputLabel>
          <Select
            disabled={this.props.selectedContextId === -1}
            width="100%"
            onChange={this.onChangeFolder}
          >
            {this.props.folderList.map(folder => (
              <option key={folder.id} value={folder.id}>
                {folder.path}
              </option>
            ))}
          </Select>
        </Field>
        <Field>
          <InputLabel>{localize('luciCategoryLabel')}</InputLabel>
          <MultiSelect
            style={{ flex: 1 }}
            options={categoryOptions}
            onChange={this.onChangeCategories}
          />
        </Field>
        <ButtonContainer paddingTop="8px">
          <Button disabled={this.props.selectedContextId === -1} onClick={this.props.onSave}>
            {localize('saveToLuciButton')}
          </Button>
        </ButtonContainer>
      </TabContentContainer>
    );
  }
}

LuciTabContent.propTypes = {
  categoryList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  contextList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  folderList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      path: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedCategoryIds: PropTypes.arrayOf(PropTypes.number),
  selectedContextId: PropTypes.number,
  onChangeCategories: PropTypes.func.isRequired,
  onChangeContext: PropTypes.func.isRequired,
  onChangeFolder: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

LuciTabContent.defaultProps = {
  selectedCategoryIds: [],
  selectedContextId: -1
};

const mapStateToProps = state => ({
  categoryList: state.publish.categoryList,
  contextList: state.publish.contextList,
  folderList: state.publish.folderList,
  selectedCategoryIds: state.publish.categoryIds,
  selectedContextId: state.publish.contextId
});

const mapDispatchToProps = dispatch => ({
  onChangeCategories: categoryId => dispatch(changeCategories(categoryId)),
  onChangeContext: contextId => dispatch(changeContext(contextId)),
  onChangeFolder: folderId => dispatch(changeFolder(folderId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LuciTabContent);



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/LuciTabContent.js